
export interface IVIPCertificatePipelineWorkSite {
	urban?: string;
	nonUrban?: string;
}


export function createCertificatePipelineWorkSite(): IVIPCertificatePipelineWorkSite {
	return {
		urban: "",
		nonUrban: "",
	}
}

export function checkCertificatePipelineWorkSite(data: IVIPCertificatePipelineWorkSite) {
	if (data.urban === undefined) {
		data.urban = "";
	}
	if (data.nonUrban === undefined) {
		data.nonUrban = "";
	}
}
